var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgOndmarcHero = function SvgOndmarcHero(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1800 1459",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1184.2 493.479c0 9.771-7.917 17.688-17.679 17.688-9.763 0-17.679-7.917-17.679-17.688 0-9.771 7.916-17.691 17.679-17.691 9.762 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#ondmarc-hero_svg__a)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.2 611.413c0 9.77-7.917 17.691-17.679 17.691-9.763 0-17.679-7.921-17.679-17.692 0-9.77 7.916-17.691 17.679-17.691 9.762 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#ondmarc-hero_svg__b)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.2 729.346c0 9.771-7.917 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692 0-9.767 7.916-17.688 17.679-17.688 9.762 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#ondmarc-hero_svg__c)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.34 847.283c0 5.425-4.396 9.83-9.821 9.83s-9.821-4.405-9.821-9.83c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#ondmarc-hero_svg__d)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.34 965.217c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.829 9.821-9.829s9.821 4.404 9.821 9.829Z",
    style: {
      fill: "url(#ondmarc-hero_svg__e)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.34 1083.15c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#ondmarc-hero_svg__f)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.34 1201.09c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.43 4.396-9.83 9.821-9.83s9.821 4.4 9.821 9.83Z",
    style: {
      fill: "url(#ondmarc-hero_svg__g)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.34 1319.02c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#ondmarc-hero_svg__h)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.05 493.479c0 9.771-7.916 17.688-17.679 17.688-9.763 0-17.679-7.917-17.679-17.688 0-9.771 7.917-17.691 17.679-17.691 9.763 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#ondmarc-hero_svg__i)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.05 611.413c0 9.77-7.916 17.691-17.679 17.691-9.763 0-17.679-7.921-17.679-17.692 0-9.77 7.917-17.691 17.679-17.691 9.763 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#ondmarc-hero_svg__j)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.05 729.346c0 9.771-7.916 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692 0-9.767 7.917-17.688 17.679-17.688 9.763 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#ondmarc-hero_svg__k)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294.2 847.283c0 5.425-4.396 9.83-9.821 9.83s-9.821-4.405-9.821-9.83c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#ondmarc-hero_svg__l)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294.2 965.217c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.829 9.821-9.829s9.821 4.404 9.821 9.829Z",
    style: {
      fill: "url(#ondmarc-hero_svg__m)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294.2 1083.15c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#ondmarc-hero_svg__n)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294.2 1201.09c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.43 4.396-9.83 9.821-9.83s9.821 4.4 9.821 9.83Z",
    style: {
      fill: "url(#ondmarc-hero_svg__o)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1294.2 1319.02c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#ondmarc-hero_svg__p)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1419.91 493.479c0 9.771-7.912 17.688-17.675 17.688-9.766 0-17.679-7.917-17.679-17.688 0-9.771 7.913-17.691 17.679-17.691 9.763 0 17.675 7.92 17.675 17.691Z",
    style: {
      fill: "url(#ondmarc-hero_svg__q)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1419.91 611.413c0 9.77-7.912 17.691-17.675 17.691-9.766 0-17.679-7.921-17.679-17.692 0-9.77 7.913-17.691 17.679-17.691 9.763 0 17.675 7.921 17.675 17.692Z",
    style: {
      fill: "url(#ondmarc-hero_svg__r)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1419.91 729.346c0 9.771-7.912 17.692-17.675 17.692-9.766 0-17.679-7.921-17.679-17.692 0-9.767 7.913-17.688 17.679-17.688 9.763 0 17.675 7.921 17.675 17.688Z",
    style: {
      fill: "url(#ondmarc-hero_svg__s)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1419.91 847.283c0 9.771-7.912 17.688-17.675 17.688-9.766 0-17.679-7.917-17.679-17.688 0-9.77 7.913-17.691 17.679-17.691 9.763 0 17.675 7.921 17.675 17.691Z",
    style: {
      fill: "url(#ondmarc-hero_svg__t)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1419.91 965.217c0 9.771-7.912 17.691-17.675 17.691-9.766 0-17.679-7.92-17.679-17.691 0-9.771 7.913-17.688 17.679-17.688 9.763 0 17.675 7.917 17.675 17.688Z",
    style: {
      fill: "url(#ondmarc-hero_svg__u)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1419.91 1083.15c0 9.767-7.912 17.688-17.675 17.688-9.766 0-17.679-7.921-17.679-17.688 0-9.771 7.913-17.691 17.679-17.691 9.763 0 17.675 7.92 17.675 17.691Z",
    style: {
      fill: "url(#ondmarc-hero_svg__v)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1419.91 1201.09c0 9.77-7.912 17.691-17.675 17.691-9.766 0-17.679-7.921-17.679-17.691 0-9.771 7.913-17.692 17.679-17.692 9.763 0 17.675 7.921 17.675 17.692Z",
    style: {
      fill: "url(#ondmarc-hero_svg__w)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1419.91 1319.02c0 9.771-7.912 17.692-17.675 17.692-9.766 0-17.679-7.921-17.679-17.692s7.913-17.688 17.679-17.688c9.763 0 17.675 7.917 17.675 17.688Z",
    style: {
      fill: "url(#ondmarc-hero_svg__x)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1559.38 493.479c0 21.709-17.587 39.313-39.287 39.313-21.696 0-39.284-17.605-39.284-39.313 0-21.712 17.588-39.312 39.284-39.312 21.7 0 39.287 17.6 39.287 39.312Z",
    style: {
      fill: "url(#ondmarc-hero_svg__y)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1549.55 611.413c0 16.283-13.192 29.483-29.466 29.483-16.271 0-29.463-13.2-29.463-29.483 0-16.284 13.192-29.484 29.463-29.484 16.274 0 29.466 13.2 29.466 29.484Z",
    style: {
      fill: "url(#ondmarc-hero_svg__z)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.77 729.346c0 9.771-7.913 17.692-17.679 17.692-9.763 0-17.68-7.921-17.68-17.692 0-9.767 7.917-17.688 17.68-17.688 9.766 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#ondmarc-hero_svg__A)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.77 847.283c0 9.771-7.913 17.688-17.679 17.688-9.763 0-17.68-7.917-17.68-17.688 0-9.77 7.917-17.691 17.68-17.691 9.766 0 17.679 7.921 17.679 17.691Z",
    style: {
      fill: "url(#ondmarc-hero_svg__B)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.77 965.217c0 9.771-7.913 17.691-17.679 17.691-9.763 0-17.68-7.92-17.68-17.691 0-9.771 7.917-17.688 17.68-17.688 9.766 0 17.679 7.917 17.679 17.688Z",
    style: {
      fill: "url(#ondmarc-hero_svg__C)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1537.77 1083.15c0 9.767-7.913 17.688-17.679 17.688-9.763 0-17.68-7.921-17.68-17.688 0-9.771 7.917-17.691 17.68-17.691 9.766 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#ondmarc-hero_svg__D)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1545.62 1201.09c0 14.112-11.433 25.55-25.537 25.55-14.1 0-25.534-11.438-25.534-25.55 0-14.113 11.434-25.555 25.534-25.555 14.104 0 25.537 11.442 25.537 25.555Z",
    style: {
      fill: "url(#ondmarc-hero_svg__E)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1545.62 1319.02c0 14.112-11.433 25.554-25.537 25.554-14.1 0-25.534-11.442-25.534-25.554 0-14.113 11.434-25.55 25.534-25.55 14.104 0 25.537 11.437 25.537 25.55Z",
    style: {
      fill: "url(#ondmarc-hero_svg__F)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1667.41 493.479c0 16.284-13.191 29.483-29.462 29.483s-29.463-13.199-29.463-29.483c0-16.283 13.192-29.483 29.463-29.483s29.462 13.2 29.462 29.483Z",
    style: {
      fill: "url(#ondmarc-hero_svg__G)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1667.41 611.413c0 16.283-13.191 29.483-29.462 29.483s-29.463-13.2-29.463-29.483c0-16.284 13.192-29.484 29.463-29.484s29.462 13.2 29.462 29.484Z",
    style: {
      fill: "url(#ondmarc-hero_svg__H)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1667.41 729.346c0 16.283-13.191 29.487-29.462 29.487s-29.463-13.204-29.463-29.487c0-16.284 13.192-29.483 29.463-29.483s29.462 13.199 29.462 29.483Z",
    style: {
      fill: "url(#ondmarc-hero_svg__I)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655.62 847.283c0 9.771-7.917 17.688-17.679 17.688-9.763 0-17.679-7.917-17.679-17.688 0-9.77 7.916-17.691 17.679-17.691 9.762 0 17.679 7.921 17.679 17.691Z",
    style: {
      fill: "url(#ondmarc-hero_svg__J)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.48 965.217c0 14.112-11.433 25.554-25.537 25.554s-25.538-11.442-25.538-25.554c0-14.113 11.434-25.55 25.538-25.55 14.104 0 25.537 11.437 25.537 25.55Z",
    style: {
      fill: "url(#ondmarc-hero_svg__K)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.48 1083.15c0 14.109-11.433 25.55-25.537 25.55s-25.538-11.441-25.538-25.55c0-14.112 11.434-25.554 25.538-25.554 14.104 0 25.537 11.442 25.537 25.554Z",
    style: {
      fill: "url(#ondmarc-hero_svg__L)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.48 1201.09c0 14.112-11.433 25.55-25.537 25.55s-25.538-11.438-25.538-25.55c0-14.113 11.434-25.555 25.538-25.555 14.104 0 25.537 11.442 25.537 25.555Z",
    style: {
      fill: "url(#ondmarc-hero_svg__M)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1677.23 1319.02c0 21.712-17.591 39.312-39.287 39.312-21.696 0-39.288-17.6-39.288-39.312 0-21.708 17.592-39.313 39.288-39.313 21.696 0 39.287 17.605 39.287 39.313Z",
    style: {
      fill: "url(#ondmarc-hero_svg__N)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.48 493.479c0 9.771-7.916 17.688-17.679 17.688-9.766 0-17.679-7.917-17.679-17.688 0-9.771 7.913-17.691 17.679-17.691 9.763 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#ondmarc-hero_svg__O)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.34 611.413c0 14.112-11.434 25.554-25.534 25.554-14.104 0-25.537-11.442-25.537-25.554 0-14.113 11.433-25.55 25.537-25.55 14.1 0 25.534 11.437 25.534 25.549Z",
    style: {
      fill: "url(#ondmarc-hero_svg__P)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1795.09 729.346c0 21.712-17.588 39.312-39.284 39.312-21.7 0-39.287-17.6-39.287-39.312 0-21.708 17.587-39.308 39.287-39.308 21.696 0 39.284 17.6 39.284 39.308Z",
    style: {
      fill: "url(#ondmarc-hero_svg__Q)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.27 847.283c0 16.284-13.192 29.484-29.463 29.484-16.275 0-29.466-13.2-29.466-29.484 0-16.283 13.191-29.483 29.466-29.483 16.271 0 29.463 13.2 29.463 29.483Z",
    style: {
      fill: "url(#ondmarc-hero_svg__R)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.27 965.217c0 16.283-13.192 29.483-29.463 29.483-16.275 0-29.466-13.2-29.466-29.483 0-16.284 13.191-29.484 29.466-29.484 16.271 0 29.463 13.2 29.463 29.484Z",
    style: {
      fill: "url(#ondmarc-hero_svg__S)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.48 1083.15c0 9.767-7.916 17.688-17.679 17.688-9.766 0-17.679-7.921-17.679-17.688 0-9.771 7.913-17.691 17.679-17.691 9.763 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#ondmarc-hero_svg__T)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.27 1201.09c0 16.283-13.192 29.483-29.463 29.483-16.275 0-29.466-13.2-29.466-29.483 0-16.284 13.191-29.484 29.466-29.484 16.271 0 29.463 13.2 29.463 29.484Z",
    style: {
      fill: "url(#ondmarc-hero_svg__U)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.34 1319.02c0 14.112-11.434 25.554-25.534 25.554-14.104 0-25.537-11.442-25.537-25.554 0-14.113 11.433-25.55 25.537-25.55 14.1 0 25.534 11.437 25.534 25.55Z",
    style: {
      fill: "url(#ondmarc-hero_svg__V)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.908 493.479c0 14.113-11.429 25.55-25.533 25.55-14.104 0-25.537-11.437-25.537-25.55 0-14.112 11.433-25.554 25.537-25.554s25.533 11.442 25.533 25.554Z",
    style: {
      fill: "url(#ondmarc-hero_svg__W)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.054 611.413c0 9.77-7.916 17.691-17.679 17.691-9.762 0-17.679-7.921-17.679-17.692 0-9.77 7.916-17.691 17.679-17.691 9.763 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#ondmarc-hero_svg__X)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.908 729.346c0 14.112-11.429 25.554-25.533 25.554-14.104 0-25.537-11.442-25.537-25.554 0-14.108 11.433-25.55 25.537-25.55s25.533 11.442 25.533 25.55Z",
    style: {
      fill: "url(#ondmarc-hero_svg__Y)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.908 847.283c0 14.113-11.429 25.55-25.533 25.55-14.104 0-25.537-11.437-25.537-25.55 0-14.112 11.433-25.554 25.537-25.554s25.533 11.442 25.533 25.554Z",
    style: {
      fill: "url(#ondmarc-hero_svg__Z)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.908 965.217c0 14.112-11.429 25.554-25.533 25.554-14.104 0-25.537-11.442-25.537-25.554 0-14.113 11.433-25.55 25.537-25.55s25.533 11.437 25.533 25.55Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aa)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.908 1083.15c0 14.109-11.429 25.55-25.533 25.55-14.104 0-25.537-11.441-25.537-25.55 0-14.112 11.433-25.554 25.537-25.554s25.533 11.442 25.533 25.554Z",
    style: {
      fill: "url(#ondmarc-hero_svg__ab)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.838 1201.09c0 16.283-13.192 29.483-29.463 29.483-16.275 0-29.467-13.2-29.467-29.483 0-16.284 13.192-29.484 29.467-29.484 16.271 0 29.463 13.2 29.463 29.484Z",
    style: {
      fill: "url(#ondmarc-hero_svg__ac)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.838 1319.02c0 16.283-13.192 29.483-29.463 29.483-16.275 0-29.467-13.2-29.467-29.483 0-16.284 13.192-29.484 29.467-29.484 16.271 0 29.463 13.2 29.463 29.484Z",
    style: {
      fill: "url(#ondmarc-hero_svg__ad)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.767 493.479c0 14.113-11.434 25.55-25.534 25.55-14.104 0-25.537-11.437-25.537-25.55 0-14.112 11.433-25.554 25.537-25.554 14.1 0 25.534 11.442 25.534 25.554Z",
    style: {
      fill: "url(#ondmarc-hero_svg__ae)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.696 611.413c0 16.283-13.192 29.483-29.463 29.483-16.275 0-29.466-13.2-29.466-29.483 0-16.284 13.191-29.484 29.466-29.484 16.271 0 29.463 13.2 29.463 29.484Z",
    style: {
      fill: "url(#ondmarc-hero_svg__af)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.517 729.346c0 21.712-17.588 39.312-39.284 39.312-21.7 0-39.287-17.6-39.287-39.312 0-21.708 17.587-39.308 39.287-39.308 21.696 0 39.284 17.6 39.284 39.308Z",
    style: {
      fill: "url(#ondmarc-hero_svg__ag)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.696 847.283c0 16.284-13.192 29.484-29.463 29.484-16.275 0-29.466-13.2-29.466-29.484 0-16.283 13.191-29.483 29.466-29.483 16.271 0 29.463 13.2 29.463 29.483Z",
    style: {
      fill: "url(#ondmarc-hero_svg__ah)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.908 965.217c0 9.771-7.912 17.691-17.675 17.691-9.766 0-17.679-7.92-17.679-17.691 0-9.771 7.913-17.688 17.679-17.688 9.763 0 17.675 7.917 17.675 17.688Z",
    style: {
      fill: "url(#ondmarc-hero_svg__ai)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.517 1083.15c0 21.708-17.588 39.309-39.284 39.309-21.7 0-39.287-17.601-39.287-39.309 0-21.712 17.587-39.312 39.287-39.312 21.696 0 39.284 17.6 39.284 39.312Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aj)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.908 1201.09c0 9.77-7.912 17.691-17.675 17.691-9.766 0-17.679-7.921-17.679-17.691 0-9.771 7.913-17.692 17.679-17.692 9.763 0 17.675 7.921 17.675 17.692Z",
    style: {
      fill: "url(#ondmarc-hero_svg__ak)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.054 1319.02c0 5.429-4.4 9.829-9.821 9.829-5.425 0-9.825-4.4-9.825-9.829 0-5.425 4.4-9.825 9.825-9.825 5.421 0 9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#ondmarc-hero_svg__al)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.767 493.479c0 9.771-7.913 17.688-17.679 17.688-9.763 0-17.68-7.917-17.68-17.688 0-9.771 7.917-17.691 17.679-17.691 9.767 0 17.68 7.92 17.68 17.691Z",
    style: {
      fill: "url(#ondmarc-hero_svg__am)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.625 611.413c0 14.112-11.433 25.554-25.537 25.554-14.1 0-25.534-11.442-25.534-25.554 0-14.113 11.434-25.55 25.534-25.55 14.104 0 25.537 11.437 25.537 25.549Z",
    style: {
      fill: "url(#ondmarc-hero_svg__an)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.625 729.346c0 14.112-11.433 25.554-25.537 25.554-14.1 0-25.534-11.442-25.534-25.554 0-14.108 11.434-25.55 25.534-25.55 14.104 0 25.537 11.442 25.537 25.55Z",
    style: {
      fill: "url(#ondmarc-hero_svg__ao)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.625 847.283c0 14.113-11.433 25.55-25.537 25.55-14.1 0-25.534-11.437-25.534-25.55 0-14.112 11.434-25.554 25.534-25.554 14.104 0 25.537 11.442 25.537 25.554Z",
    style: {
      fill: "url(#ondmarc-hero_svg__ap)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.625 965.217c0 14.112-11.433 25.554-25.537 25.554-14.1 0-25.534-11.442-25.534-25.554 0-14.113 11.434-25.55 25.534-25.55 14.104 0 25.537 11.437 25.537 25.55Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aq)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.625 1083.15c0 14.109-11.433 25.55-25.537 25.55-14.1 0-25.534-11.441-25.534-25.55 0-14.112 11.434-25.554 25.534-25.554 14.104 0 25.537 11.442 25.537 25.554Z",
    style: {
      fill: "url(#ondmarc-hero_svg__ar)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.767 1201.09c0 9.77-7.913 17.691-17.679 17.691-9.763 0-17.68-7.921-17.68-17.691 0-9.771 7.917-17.692 17.679-17.692 9.767 0 17.68 7.921 17.68 17.692Z",
    style: {
      fill: "url(#ondmarc-hero_svg__as)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.767 1319.02c0 9.771-7.913 17.692-17.679 17.692-9.763 0-17.68-7.921-17.68-17.692s7.917-17.688 17.679-17.688c9.767 0 17.68 7.917 17.68 17.688Z",
    style: {
      fill: "url(#ondmarc-hero_svg__at)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.625 493.479c0 9.771-7.917 17.688-17.679 17.688-9.763 0-17.679-7.917-17.679-17.688 0-9.771 7.916-17.691 17.679-17.691 9.762 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#ondmarc-hero_svg__au)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.625 611.413c0 9.77-7.917 17.691-17.679 17.691-9.763 0-17.679-7.921-17.679-17.692 0-9.77 7.916-17.691 17.679-17.691 9.762 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#ondmarc-hero_svg__av)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.625 729.346c0 9.771-7.917 17.692-17.679 17.692-9.763 0-17.679-7.921-17.679-17.692 0-9.767 7.916-17.688 17.679-17.688 9.762 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aw)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.625 847.283c0 9.771-7.917 17.688-17.679 17.688-9.763 0-17.679-7.917-17.679-17.688 0-9.77 7.916-17.691 17.679-17.691 9.762 0 17.679 7.921 17.679 17.691Z",
    style: {
      fill: "url(#ondmarc-hero_svg__ax)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.625 965.217c0 9.771-7.917 17.691-17.679 17.691-9.763 0-17.679-7.92-17.679-17.691 0-9.771 7.916-17.688 17.679-17.688 9.762 0 17.679 7.917 17.679 17.688Z",
    style: {
      fill: "url(#ondmarc-hero_svg__ay)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.625 1083.15c0 9.767-7.917 17.688-17.679 17.688-9.763 0-17.679-7.921-17.679-17.688 0-9.771 7.916-17.691 17.679-17.691 9.762 0 17.679 7.92 17.679 17.691Z",
    style: {
      fill: "url(#ondmarc-hero_svg__az)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.625 1201.09c0 9.77-7.917 17.691-17.679 17.691-9.763 0-17.679-7.921-17.679-17.691 0-9.771 7.916-17.692 17.679-17.692 9.762 0 17.679 7.921 17.679 17.692Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aA)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.767 1319.02c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aB)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.625 493.479c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aC)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.625 611.413c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.43 4.396-9.83 9.821-9.83s9.821 4.4 9.821 9.83Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aD)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.483 729.346c0 9.771-7.916 17.692-17.679 17.692-9.766 0-17.679-7.921-17.679-17.692 0-9.767 7.913-17.688 17.679-17.688 9.763 0 17.679 7.921 17.679 17.688Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aE)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.625 847.283c0 5.425-4.396 9.83-9.821 9.83s-9.821-4.405-9.821-9.83c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aF)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.625 965.217c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.829 9.821-9.829s9.821 4.404 9.821 9.829Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aG)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.625 1083.15c0 5.425-4.396 9.825-9.821 9.825s-9.821-4.4-9.821-9.825c0-5.429 4.396-9.829 9.821-9.829s9.821 4.4 9.821 9.829Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aH)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.625 1201.09c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.43 4.396-9.83 9.821-9.83s9.821 4.4 9.821 9.83Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aI)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.625 1319.02c0 5.429-4.396 9.829-9.821 9.829s-9.821-4.4-9.821-9.829c0-5.425 4.396-9.825 9.821-9.825s9.821 4.4 9.821 9.825Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aJ)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.48 493.479c0 5.425-4.4 9.825-9.825 9.825-5.42 0-9.82-4.4-9.82-9.825 0-5.429 4.4-9.829 9.82-9.829 5.425 0 9.825 4.4 9.825 9.829Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aK)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.48 611.413c0 5.429-4.4 9.829-9.825 9.829-5.42 0-9.82-4.4-9.82-9.829 0-5.43 4.4-9.83 9.82-9.83 5.425 0 9.825 4.4 9.825 9.83Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aL)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.34 729.346c0 9.771-7.913 17.692-17.68 17.692-9.762 0-17.675-7.921-17.675-17.692 0-9.767 7.913-17.688 17.675-17.688 9.767 0 17.68 7.921 17.68 17.688Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aM)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.48 847.283c0 5.425-4.4 9.83-9.825 9.83-5.42 0-9.82-4.405-9.82-9.83 0-5.429 4.4-9.829 9.82-9.829 5.425 0 9.825 4.4 9.825 9.829Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aN)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.48 965.217c0 5.429-4.4 9.829-9.825 9.829-5.42 0-9.82-4.4-9.82-9.829 0-5.425 4.4-9.829 9.82-9.829 5.425 0 9.825 4.404 9.825 9.829Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aO)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.48 1083.15c0 5.425-4.4 9.825-9.825 9.825-5.42 0-9.82-4.4-9.82-9.825 0-5.429 4.4-9.829 9.82-9.829 5.425 0 9.825 4.4 9.825 9.829Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aP)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.48 1201.09c0 5.429-4.4 9.829-9.825 9.829-5.42 0-9.82-4.4-9.82-9.829 0-5.43 4.4-9.83 9.82-9.83 5.425 0 9.825 4.4 9.825 9.83Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aQ)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.48 1319.02c0 5.429-4.4 9.829-9.825 9.829-5.42 0-9.82-4.4-9.82-9.829 0-5.425 4.4-9.825 9.82-9.825 5.425 0 9.825 4.4 9.825 9.825Z",
    style: {
      fill: "url(#ondmarc-hero_svg__aR)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.167 0c402.708 0 729.166 326.459 729.166 729.167s-326.458 729.166-729.166 729.166c-13.359 0-26.634-.358-39.817-1.066-160.667-8.65-307.517-69.309-424.002-165.442a733.196 733.196 0 0 1-101.576-102.175C68.769 1073.146 9.061 926.725.949 766.692a740.119 740.119 0 0 1-.537-62.229 736.95 736.95 0 0 1 .694-15.805c8.782-160.396 69.405-306.993 165.4-423.31a733.748 733.748 0 0 1 102.227-101.619C385.228 68.751 531.633 9.059 691.642.949A740.09 740.09 0 0 1 729.167 0Zm0 416.667H281.25v625h447.917V854.442L371.849 613.425c-21.271-14.346-26.884-43.221-12.535-64.492 14.346-21.271 43.223-26.883 64.494-12.537l305.359 205.971v-325.7Zm0 0h447.916v625H729.167V1375C1085.85 1375 1375 1085.85 1375 729.167c0-356.685-289.15-645.834-645.833-645.834v333.334Zm0 437.775 357.316-241.013c21.271-14.35 26.884-43.225 12.538-64.496-14.346-21.271-43.225-26.883-64.496-12.537L729.167 742.367v112.075Z",
    style: {
      fill: "#96d36e"
    }
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__a",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__b",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__c",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__d",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__e",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__f",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__h",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__i",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__j",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__k",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__l",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__m",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__n",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__o",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__p",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__q",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__r",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__s",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__t",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__u",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__v",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__w",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__x",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__y",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__z",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__A",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__B",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__C",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__D",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__E",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__F",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__G",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__H",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__I",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__J",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__K",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__L",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__M",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__N",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__O",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__P",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__Q",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__R",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__S",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__T",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__U",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__V",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__W",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__X",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__Y",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__Z",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aa",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__ab",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__ac",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__ad",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__ae",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__af",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__ag",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__ah",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__ai",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aj",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__ak",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__al",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__am",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__an",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__ao",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__ap",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aq",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__ar",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__as",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__at",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__au",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__av",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aw",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__ax",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__ay",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__az",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aA",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aB",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aC",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aD",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aE",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aF",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aG",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aH",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aI",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aJ",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aK",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aL",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aM",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aN",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aO",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aP",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aQ",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ondmarc-hero_svg__aR",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(-1651.233) rotate(33.617 .82 -2.26)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b6b6b6",
      stopOpacity: 0
    }
  }))));
};
export default SvgOndmarcHero;